module.exports = __webpack_public_path__ + "img/executor.e835de45.svg";